import { render } from "./UsageStatsDetailTable.vue?vue&type=template&id=cca17f9c&scoped=true"
import script from "./UsageStatsDetailTable.vue?vue&type=script&lang=js"
export * from "./UsageStatsDetailTable.vue?vue&type=script&lang=js"

import "./UsageStatsDetailTable.vue?vue&type=style&index=0&id=cca17f9c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\hagino\\work\\src\\plus-manabi\\mplus-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cca17f9c"]])

export default __exports__